import React, { createContext, PropsWithChildren, useState } from 'react';
import { useRouter } from 'next/router';
import { ChannelsList } from '@/lib/types';
import OverlayChannelCreate from '@/components/overlay/OverlayChannelCreate';
import { OverlayType } from '@/lib/enums/OverlayType.enum';
import useOverlayActions from '@/lib/hooks/useOverlayActions';
import { ChannelId } from '@/lib/enums/ChannelId.enum';

export const defaultChannel = ChannelId.aripaev;

const createNewOption = {
  id: '__new__',
  label: '- lisa uus -',
  logo: '',
};

export interface IChannelContext extends ChannelsList {
  channelId: string;
  selectChannel: (id: string) => void;
  channel?: IChannel;
}

export type IChannel = {
  id: string;
  label: string;
  logo?: string;
};

export const ChannelContext = createContext<IChannelContext>({
  channelId: defaultChannel,
  channels: [],
  creatableIds: [],
  selectChannel: () => void 0,
  channel: {
    id: '',
    label: '',
    logo: '',
  },
});

const Channel: React.FC<PropsWithChildren<Omit<IChannelContext, 'selectChannel'>>> = ({ channelId, channels, creatableIds, children }) => {
  const getActiveChannel = (selectedId: string) => {
    return channels.find(({ id }) => id === selectedId);
  };

  const { open } = useOverlayActions();
  const router = useRouter();
  const [channel, setChannel] = useState<IChannel | undefined>(getActiveChannel(channelId));

  const selectChannel = (id: string) => {
    if (id === createNewOption.id) {
      open(OverlayType.channel_create);
    } else {
      setChannel(getActiveChannel(id));
      void router.push(`/${id}/outlets`);
    }
  };

  return (
    <ChannelContext.Provider
      value={{
        channelId,
        channels: [...channels, createNewOption],
        creatableIds,
        selectChannel,
        channel,
      }}
    >
      {children}
      <OverlayChannelCreate />
    </ChannelContext.Provider>
  );
};

export default Channel;
